export const getFileUrl = (path: string | undefined | null): string => {
    if (!path) return '';
    
    // API'nin base URL'ini process.env'den alın veya sabit olarak tanımlayın
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    
    // Path zaten tam URL içeriyorsa, direkt döndür
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    
    // Path'in başındaki ve sonundaki tüm slash'ları temizle
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    
    // uploads/ prefix'i zaten varsa onu da kaldır
    const finalPath = normalizedPath.startsWith('uploads/') 
        ? normalizedPath.substring(8) 
        : normalizedPath;
        
    return `${API_BASE_URL}/uploads/${finalPath}`;
};

export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};